import { useState } from "react";
import { Link } from "react-router-dom";

export default function CustomerListPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("all");

  const customers = [
    { name: "ABC Ticaret Ltd. Şti.", code: "BAY-001", phone: "0532 111 22 33", city: "İstanbul", balance: 12450, status: "active" },
    { name: "XYZ Market", code: "BAY-002", phone: "0533 444 55 66", city: "Ankara", balance: -3200, status: "active" },
    { name: "Mega Gıda", code: "BAY-003", phone: "0544 777 88 99", city: "İzmir", balance: 0, status: "inactive" },
    { name: "Kaya Elektronik", code: "BAY-004", phone: "0555 000 11 22", city: "Bursa", balance: 8760, status: "active" },
    { name: "Sarı Giyim", code: "BAY-005", phone: "0536 333 44 55", city: "İstanbul", balance: -1500, status: "active" },
    { name: "Deniz Toptan", code: "BAY-006", phone: "0537 666 77 88", city: "Antalya", balance: 23400, status: "active" },
  ];

  const filtered = customers.filter((item) => {
    if (filter === "active") return item.status === "active";
    if (filter === "inactive") return item.status === "inactive";
    if (filter === "debt") return item.balance < 0;
    if (filter === "credit") return item.balance > 0;
    return true;
  }).filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.code.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalDebt = customers.filter(c => c.balance < 0).reduce((sum, c) => sum + Math.abs(c.balance), 0);
  const totalCredit = customers.filter(c => c.balance > 0).reduce((sum, c) => sum + c.balance, 0);

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-foreground-950">Müşteri Listesi</h1>
          <p className="text-sm text-foreground-500 mt-0.5">
            Tüm bayi ve müşteri bilgileri ile bakiye durumları
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button className="flex items-center gap-1.5 px-3 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-download-2-line"></i>
            <span className="hidden sm:inline">İndir</span>
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-user-star-line text-primary-600 text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-foreground-500">Toplam Müşteri</p>
              <p className="text-xl font-bold text-foreground-950">{customers.length}</p>
            </div>
          </div>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
              <i className="ri-arrow-down-circle-line text-accent-600 text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-foreground-500">Toplam Borç</p>
              <p className="text-xl font-bold text-foreground-950">${totalDebt.toLocaleString("en-US")}</p>
            </div>
          </div>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center">
              <i className="ri-arrow-up-circle-line text-secondary-600 text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-foreground-500">Toplam Alacak</p>
              <p className="text-xl font-bold text-foreground-950">${totalCredit.toLocaleString("en-US")}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="relative flex-1 max-w-sm">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
          <input
            type="text"
            placeholder="Müşteri adı veya kodu ara..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400"
          />
        </div>
        <div className="flex items-center gap-1.5 bg-background-100 border border-background-200/70 rounded-lg p-0.5 flex-wrap">
          {[
            { key: "all", label: "Tümü" },
            { key: "active", label: "Aktif" },
            { key: "inactive", label: "Pasif" },
            { key: "debt", label: "Borçlu" },
            { key: "credit", label: "Alacaklı" },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => setFilter(tab.key)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                filter === tab.key
                  ? "bg-background-50 text-foreground-950 shadow-sm"
                  : "text-foreground-500 hover:text-foreground-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Müşteri</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Kod</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Telefon</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Şehir</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Bakiye</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Durum</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((item) => (
              <tr key={item.code} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 font-medium text-foreground-900">{item.name}</td>
                <td className="px-4 py-3 text-foreground-500">{item.code}</td>
                <td className="px-4 py-3 text-foreground-500">{item.phone}</td>
                <td className="px-4 py-3 text-foreground-500">{item.city}</td>
                <td className={`px-4 py-3 text-right font-medium ${item.balance < 0 ? "text-accent-600" : item.balance > 0 ? "text-primary-600" : "text-foreground-500"}`}>
                  ${item.balance.toLocaleString("en-US")}
                </td>
                <td className="px-4 py-3 text-center">
                  <span
                    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                      item.status === "active"
                        ? "bg-primary-100 text-primary-700"
                        : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    <i className={item.status === "active" ? "ri-check-line" : "ri-close-line"}></i>
                    {item.status === "active" ? "Aktif" : "Pasif"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="lg:hidden space-y-3">
        {filtered.map((item) => (
          <div key={item.code} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                <p className="text-xs text-foreground-400 mt-0.5">{item.code} · {item.city}</p>
              </div>
              <span
                className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium shrink-0 ${
                  item.status === "active"
                    ? "bg-primary-100 text-primary-700"
                    : "bg-background-100 text-foreground-500"
                }`}
              >
                <i className={item.status === "active" ? "ri-check-line" : "ri-close-line"}></i>
                {item.status === "active" ? "Aktif" : "Pasif"}
              </span>
            </div>
            <div className="flex items-center gap-4 mt-3">
              <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-phone-line"></i>
                {item.phone}
              </div>
            </div>
            <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/50">
              <span className="text-xs text-foreground-400">Bakiye</span>
              <span className={`text-sm font-semibold ${item.balance < 0 ? "text-accent-600" : item.balance > 0 ? "text-primary-600" : "text-foreground-500"}`}>
                ${item.balance.toLocaleString("en-US")}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Back to reports */}
      <div className="flex justify-start">
        <Link
          to="/reports/sales-purchases"
          className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          Satış - Alış Raporlarına Dön
        </Link>
      </div>
    </div>
  );
}